
import * as types from './actionTypes';

export const getOrders = (orderType, params) => ({type: types.ORDER_LIST_GET, orderType, params });

export const getOrdersSuccess = (orderType,payload) => ({type: types.ORDER_LIST_SUCCESS, orderType, payload})

export const getOrderFail = (error) => ({ type: types.ORDER_LIST_FAIL, error });
